var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.returns-treated'),"text":_vm.$t('returnedArticles.description'),"name":"ordersReturnsTreated","url":_vm.$listRoutes.ordersReturns,"table":_vm.ordersReturnsTreated,"filters":_vm.ordersReturnsTreatedFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }